import React from 'react';
import {useTranslation} from "react-i18next";
import {Outlet, useLocation, useParams} from "react-router-dom";
import {Layout} from "antd";
import "./template.css";
import {EMenu} from "../screens/tracking/type";

export const NavbarTemplate = () => {
    let {pathname} = useLocation();
    let {tracking} = useParams();
    const {t} = useTranslation("tracking");
    let opt = EMenu.search;
    if (pathname.includes(EMenu.reqReturn)) {
        opt = EMenu.reqReturn;
    } else if (pathname.includes(EMenu.return)) {
        opt = EMenu.return;
    } else if (pathname.includes(EMenu.info)) {
        opt = EMenu.info;
    } else if (pathname.includes(EMenu.entrance)) {
        opt = EMenu.entrance;
    } else if (pathname.includes(EMenu.exchange)) {
        opt = EMenu.exchange;
    } else if (tracking) {
        opt = EMenu.tracking;
    }

    return (<Layout className={"container"}>
        <nav className={'navbar'}>
           <span data-cy={'titleNode'} className={'text'}>
              {t(`${opt || "search"}.title`)}
            </span>
        </nav>
        <Outlet/>
    </Layout>);
};
